export default __webpack_public_path__ + "static/media/Mädchen-mit-Meerschweinchen.8aea2a1e.webp";